module.exports = __webpack_public_path__ + "static/media/file_theme1.9aa435ce.svg";